import angular from "angular";
import param from "../param";
import core from "../../core/core.module";

angular
    .module('paramsControl.paramForm', [param, core])
    .component('paramForm', {
        template: require('./param-form.html'),
        controller: ['Param', 'notifier', controller],
        bindings: {
            resolve: '<',
            dismiss: '&',
            close: '&'
        }
    });

function controller(Param, notifier) {

    let $ctrl = this;

    $ctrl.$onInit = function () {

        $ctrl.primaryKey = null;
        $ctrl.key = null;
        $ctrl.description = null;
        $ctrl.value = null;

        if ($ctrl.resolve.param) {
            let param = $ctrl.resolve.param;
            $ctrl.primaryKey = param.key;
            $ctrl.key = param.key;
            $ctrl.description = param.description;
            $ctrl.value = param.value;
        }
    };

    $ctrl.submit = function () {

        let params = {
            key: $ctrl.key,
            description: $ctrl.description,
            value: $ctrl.value
        };

        let defer = $ctrl.primaryKey ? Param.update($ctrl.primaryKey, params) : Param.store(params);

        $ctrl.loading = true;

        defer.then(
            function () {
                $ctrl.loading = false;
                $ctrl.close({
                    $value: params
                });
            },
            function (error) {
                $ctrl.loading = false;
                notifier.errorResponseNotify(error);
            }
        );

    };
}

export default 'paramsControl.paramForm';


// WEBPACK FOOTER //
// ./resources/assets/modules/params-control/param-form/param-form.js